import { Controller } from "@hotwired/stimulus";

// Bulk-pay toolbar on the brand Payments list. The row checkboxes live in the
// table but post to the toolbar's #bulkPayForm via HTML5 `form=`, so submission
// needs no JS. This controller drives the live count + total and gates the
// submit behind a confirm sheet (total charged + which saved card). The server
// re-checks each row's authority + payable state and locks the amount to the DB,
// so a stray submit is safe — this is UX, not a trust boundary.
export default class extends Controller {
  static targets = [
    "checkbox",
    "count",
    "open",
    "sheet",
    "sheetCount",
    "sheetTotal",
  ];

  connect() {
    this._n = 0;
    this._cents = 0;
    this.toggle();
  }

  toggle() {
    const checked = this.checkboxTargets.filter((c) => c.checked);
    this._n = checked.length;
    // Sum the GROSSED-UP charge (net + card fee) — that's what the card is
    // actually charged, so the sheet total isn't understated.
    this._cents = checked.reduce(
      (sum, c) => sum + parseInt(c.dataset.chargeCents || "0", 10),
      0
    );

    if (this.hasOpenTarget) this.openTarget.disabled = this._n === 0;
    if (this.hasCountTarget)
      this.countTarget.textContent = this._n > 0 ? ` (${this._n})` : "";

    // If the sheet is open while the selection changes, keep it in sync.
    if (
      this.hasSheetTarget &&
      !this.sheetTarget.classList.contains("is-hidden")
    )
      this.fillSheet();
  }

  openSheet() {
    if (this._n === 0) return;
    this.fillSheet();
    if (this.hasSheetTarget) this.sheetTarget.classList.remove("is-hidden");
  }

  closeSheet() {
    if (this.hasSheetTarget) this.sheetTarget.classList.add("is-hidden");
  }

  fillSheet() {
    if (this.hasSheetCountTarget)
      this.sheetCountTarget.textContent = `${this._n} ${
        this._n === 1 ? "creator" : "creators"
      }`;
    if (this.hasSheetTotalTarget)
      this.sheetTotalTarget.textContent = this.formatUsd(this._cents);
  }

  formatUsd(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: "currency",
      currency: "USD",
    });
  }
}
